var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn rounded-0",class:_vm.classes,attrs:{"type":"button","disabled":_vm.disabled,"hidden":_vm.hidden},on:{"click":_vm.onButtonClick}},[(_vm.loading)?_c('b-spinner',{staticClass:"mr-2",staticStyle:{"width":"20px","height":"20px","opacity":"1"}}):[_vm._t("default"),_vm._v(_vm._s(_vm.text)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }